import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationsSelector } from '../selectors'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export function* setDose() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const { dose, patientMedication, patientMedicationsList } = patientMedications
  const selectedMedication = patientMedicationsList.filter((medication) => medication.key === patientMedication?.key)
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].dose = dose
    yield put(setPatientMedicationsList(patientMedicationsList))
  }
}
export function* setDoseSaga() {
  yield takeLatest([PatientMedicationsConstants.SET_DOSE], setDose)
}
